import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=c8ed358c&scoped=true&lang=true&"
import script from "./Cards.vue?vue&type=script&lang=js&"
export * from "./Cards.vue?vue&type=script&lang=js&"
import style0 from "./Cards.vue?vue&type=style&index=0&id=c8ed358c&lang=scss&scoped=true&"
import style1 from "./Cards.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ed358c",
  null
  
)

export default component.exports